export enum StorageKey {
  USER_TIMEZONE = "userTimezone",
  SESSION = "session",
}

export class Storage {
  // eslint-disable-next-line no-use-before-define
  private static instance: Storage;

  // Private constructor to enforce singleton pattern
  // eslint-disable-next-line no-useless-constructor, @typescript-eslint/no-empty-function
  private constructor() {}

  static getInstance(): Storage {
    if (!Storage.instance) {
      Storage.instance = new Storage();
    }
    return Storage.instance;
  }

  get(key: StorageKey): string | null {
    return localStorage.getItem(key);
  }

  set(key: StorageKey, value: string): void {
    localStorage.setItem(key, value);
  }

  remove(key: StorageKey): void {
    localStorage.removeItem(key);
  }

  clear(): void {
    localStorage.clear();
  }

  getParsed<T>(key: StorageKey): T | null {
    try {
      const value = this.get(key);
      return value ? JSON.parse(value) : null;
    } catch {
      return null;
    }
  }

  setStringified(key: StorageKey, value: unknown): void {
    this.set(key, JSON.stringify(value));
  }
}

export const storage = Storage.getInstance();
